import { useCookies } from 'react-cookie';
import AuthUtils from '../../utils/auth.utils';
import { USER_IN_SESSION_KEY } from './useAuthUser';

const useAuthCookie = () => {
  const [, setCookie, removeCookie] = useCookies();

  const setTokenCookies = (session: TokenData) => {
    setCookie(AuthUtils.tokenNames.accessToken, session.accessToken, {
      ...AuthUtils.cookieConfig().options,
      expires: new Date(session.accessTokenExpirationDate),
    });
    setCookie(
      `${AuthUtils.tokenNames.accessToken}_expires`,
      new Date(session.accessTokenExpirationDate).getTime().toString(),
      {
        ...AuthUtils.cookieConfig().options,
        expires: new Date(session.accessTokenExpirationDate),
      }
    );
    setCookie(AuthUtils.tokenNames.refreshToken, session.refreshToken, {
      ...AuthUtils.cookieConfig().options,
      expires: new Date(session.refreshTokenExpirationDate),
    });
    setCookie(
      `${AuthUtils.tokenNames.refreshToken}_expires`,
      new Date(session.refreshTokenExpirationDate).getTime().toString(),
      {
        ...AuthUtils.cookieConfig().options,
        expires: new Date(session.refreshTokenExpirationDate),
      }
    );
  };

  const getUserInSessionCookie = () => {
    return AuthUtils.getCookieByKey(USER_IN_SESSION_KEY);
  };

  const setUserInSessionCookie = (data: UserCookieSessionData, expirationDate: string) => {
    setCookie(USER_IN_SESSION_KEY, JSON.stringify(data), {
      ...AuthUtils.cookieConfig().options,
      expires: new Date(expirationDate),
    });
  };

  const removeTokenCookies = () => {
    removeCookie(AuthUtils.tokenNames.accessToken, AuthUtils.cookieConfig().options);
    removeCookie(`${AuthUtils.tokenNames.accessToken}_expires`, AuthUtils.cookieConfig().options);
    removeCookie(AuthUtils.tokenNames.refreshToken, AuthUtils.cookieConfig().options);
    removeCookie(`${AuthUtils.tokenNames.refreshToken}_expires`, AuthUtils.cookieConfig().options);
  };

  const removeUserInSessionCookie = () => {
    removeCookie(USER_IN_SESSION_KEY, AuthUtils.cookieConfig().options);
  };

  return {
    setTokenCookies,
    removeTokenCookies,
    getUserInSessionCookie,
    setUserInSessionCookie,
    removeUserInSessionCookie,
  };
};

export default useAuthCookie;
